import React from "react";
import ReactDOM from "react-dom/client";
import { AppNext } from "./next/AppNext";
import { installErasePeer } from "./next/eraseChannel";
import { ErrorBoundaryNext } from "./next/ErrorBoundaryNext";
import { GlobalErrorToasts } from "./next/GlobalErrorToasts";
import { LocaleProvider } from "./next/i18n";
import { initLaunchQueue } from "./next/launchIntake";
import { ToastProvider } from "./next/Toast";
import { registerServiceWorker } from "./sw-register";
import { installGlobalErrorHandlers } from "./utils/globalErrorHandlers";
import "./next/next.css";

// Before the first render: an error thrown during boot (a failed dynamic
// import, a throwing module side effect) escapes React entirely, so the
// listeners have to already be there to log it. GlobalErrorToasts, mounted
// below, hands them the live toast once there is a surface to show one on.
installGlobalErrorHandlers();

// Before the first render as well, and for a related reason: "Erase everything
// stored by this site" is pressed in ONE tab, and `sessionStorage` is scoped
// per browsing context, so the tab holding the message that needs erasing has
// to answer for its own area. It is never the tab looking at Settings, so the
// listener belongs at boot rather than in the view that starts the round.
installErasePeer();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundaryNext>
      <LocaleProvider>
        <ToastProvider>
          <GlobalErrorToasts />
          <AppNext />
        </ToastProvider>
      </LocaleProvider>
    </ErrorBoundaryNext>
  </React.StrictMode>,
);

// Offline-first: register the same-origin, cache-first service worker. PROD-only
// (the helper skips dev hosts), fire-and-forget — a failed SW never breaks the app.
registerServiceWorker();

// OS file-open (manifest file_handlers): register the launchQueue consumer
// early so a launch that races the React mount is buffered, not dropped.
initLaunchQueue();
